import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateBlockV3 = OpalApi<'UpdateBlockV3', 200>

export const updateBlock: UpdateBlockV3 = async (args = {}) => {
  const url = new URL(
    `/loupe/v3/blocks/${args.params?.path.block_id}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
